/* GENERATED with v0.0.117 of https://github.beeone.at/George/ibo
 * FROM v2.7.1 of "Payments service"
 * CHANGES WILL BE LOST, DO NOT MAKE MANUAL CHANGES
 */
/* istanbul ignore file */
/* eslint-disable */

import type { MoneyAmount } from './MoneyAmount';

export type Fee = {
    description?: string;
    amount?: MoneyAmount;
    type: Fee.type;
};

export namespace Fee {

    export enum type {
        TRANSFER_AMOUNT = 'TRANSFER_AMOUNT',
        FEE = 'FEE',
        TOTAL_AMOUNT_WITH_FEES = 'TOTAL_AMOUNT_WITH_FEES',
        TOTAL_FEES = 'TOTAL_FEES',
    }


}

